import { render, staticRenderFns } from "./AlternativeItemSelector.vue?vue&type=template&id=026189ea&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./AlternativeItemSelector.vue?vue&type=script&lang=js&"
export * from "./AlternativeItemSelector.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeItemSelector.vue?vue&type=style&index=0&id=026189ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../checkout/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026189ea",
  null
  
)

export default component.exports